import React from 'react';

import moment from 'moment';
import { DataTableFilterMetaData } from 'primereact/datatable';

import {
  TaskForCalendarAssignment,
  TimelineItem,
  TimelineScale
} from '../../types/interfaces';

export type CalendarViewMode = 'schedule' | 'timesheet';

export type SortField = 'name' | 'personnelNumber' | 'none';
export type SortDirection = 'asc' | 'desc' | 'none';

export interface SortConfig {
  sortBy: SortField;
  sortDirection: SortDirection;
}

export interface CustomTimelineItem extends TimelineItem {
  data?: {
    type: 'task' | 'total';
    personId?: number;
    day?: string;
    tasks?: TaskForCalendarAssignment[];
  };
}

export interface TimelineGroup {
  id: number | string;
  title: React.ReactNode;
}

export interface CalendarAssignmentsDesktopLayout {
  contentMinWidth: number;
  timelineMinWidth: number;
  sidebarInfoWidth: number;
  totalColumnWidth: number;
  lineHeight: number;
  departmentScheduleGroupId: number;
}

export const CALENDAR_ASSIGNMENTS_DESKTOP_LAYOUT: CalendarAssignmentsDesktopLayout =
  {
    contentMinWidth: 1450,
    timelineMinWidth: 1300,
    sidebarInfoWidth: 250,
    totalColumnWidth: 60,
    lineHeight: 60,
    departmentScheduleGroupId: -1
  };

export interface CalendarAssignmentsTimelineModel {
  startOfMonth: moment.Moment;
  daysInMonth: number;
  groups: TimelineGroup[];
  items: TimelineItem[];
  timelineScale: TimelineScale;
  visibleTimeRange: moment.Moment;
  visibleTimeStart: number;
  visibleTimeEnd: number;
  monthDurationMs: number;
  sidebarWidth: number;
  timelineVersion: number;
  selectedItemIds: number[];
  filters: Record<string, DataTableFilterMetaData>;
  sortBy: SortField;
  sortDirection: SortDirection;
  showOnlyFreeEmployees: boolean;
  excludeLongAbsences: boolean;
  todayShiftOnly: boolean;
}

export interface CalendarAssignmentsTimelineActions {
  onFilterChange: (
    filter: 'name' | 'personnelNumber',
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  onSortChange: (field: 'name' | 'personnelNumber') => void;
  onScaleChange: (newScale: TimelineScale, date?: moment.Moment) => void;
  onTimeChange: (
    visibleTimeStart: number,
    visibleTimeEnd: number,
    updateScrollCanvas: (start: number, end: number) => void,
    unit?: string
  ) => void;
  onToggleFreeEmployeesFilter: () => void;
  onToggleExcludeLongAbsences: () => void;
  onToggleTodayShiftOnly: () => void;
  onItemSelect: (
    itemId: number,
    event: React.SyntheticEvent,
    time: number
  ) => void;
  onItemDeselect: () => void;
  onItemDoubleClick: (itemId: string | number) => void;
}
